export default __webpack_public_path__ + "static/media/discover.d5b93b0b.svg";